module.exports = __webpack_public_path__ + "static/0032-b8663dc2cc2adb2e49ad0251a57a6275.png";